import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const GoogleMapComponent = ({ courtData, onCourtSelect, height , onShowMapModal}) => {

  const defaultCenter = {
    lat: 28.7041,
    lng: 77.1025,
  };

  const [selectedLocation, setSelectedLocation] = useState(defaultCenter);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const navigate = useNavigate();

  const containerStyle = {
    width: "100%",
    height: height || "500px",
  };

  useEffect(() => {
    if (courtData && courtData.length > 0) {
      setSelectedLocation({ lat: courtData[0].latitude, lng: courtData[0].longitude });
    }
  }, [courtData]);

  const handleMapClick = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setSelectedLocation({ lat, lng });

    try {
      const response = await fetch(`${process.env.REACT_APP_GOOGLE_GEOCODE_URL}?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`);
      const data = await response.json();

      if (data.status === 'OK' && data.results.length > 0) {
        const address = data.results[0].formatted_address;
        // toast.success(`Address: ${address}`);
      } else {
        toast.error("No address found for this location");
      }
    } catch (error) {
      toast.error("Failed to fetch address");
    }
  };


  const handleMarkerClick = (court) => {
    onCourtSelect(court);
    setSelectedCourt(court);
    setSelectedLocation({ lat: court.latitude, lng: court.longitude });
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={selectedLocation}
        zoom={10}
        onClick={handleMapClick}
      >
      
        <Marker position={selectedLocation} />

        {courtData?.map((court) => (
          <Marker
            key={court.id}
            position={{ lat: court.latitude, lng: court.longitude }}
            onClick={() => handleMarkerClick(court)}
          />
        ))}

        {selectedCourt && (
          <InfoWindow
            position={{ lat: selectedCourt.latitude, lng: selectedCourt.longitude }}
            onCloseClick={() => setSelectedCourt(null)}
          >
            <div   style={{ cursor: selectedCourt.games && selectedCourt.games.length > 0 ? 'pointer' : 'default' }}
                onClick={() => {
                  if (!selectedCourt?.games || selectedCourt?.games.length === 0) return;

                  if (selectedCourt.games.length === 1) {
                    navigate(`/game-details/${selectedCourt.games[0].gameId}`);
                  } else {
                     onShowMapModal(false)
                    navigate('/explore', { state: { mapView: false } });
                  }
                }}>
              <h4>{selectedCourt.courtName}</h4>
              <p>{selectedCourt.address}</p>
              <p><strong>Phone:</strong> {selectedCourt.phone || "N/A"}</p>

              <h5>
                {!selectedCourt.games || selectedCourt.games.length === 0
                  ? 'No Game'
                  : selectedCourt.games.length > 1
                    ? 'Multiple Games'
                    : selectedCourt.games[0].gameName}
              </h5>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
